import { AppConstant } from './../utilities/app.constants';
import { Injectable, Injector } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError, of } from 'rxjs';
import { map, catchError, finalize } from 'rxjs/operators';
import { AppSpinnerService } from '../services/app-spinner.service';
import { Router } from '@angular/router';
@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
    constructor(private injector: Injector, private router: Router) {}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        // request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        
        request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token')) });
        request = request.clone({ headers: request.headers.set('ApplicationName', 'AnalyticsWeb') });
        const spinnerService = this.injector.get(AppSpinnerService);
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                console.log('HttpResponse1', event);
                if (event instanceof HttpResponse) {
                    console.log('HttpResponse2', event);
                }
                return event;
            }),
            // catchError((err: any) => {
            //     // console.log('res err', err);
            //     if(err instanceof HttpErrorResponse) {
            //         // try {
            //         //     this.toasterService.error(err.error.message, err.error.title, { positionClass: 'toast-bottom-center' });
            //         // } catch(e) {
            //         //     this.toasterService.error('An error occurred', '', { positionClass: 'toast-bottom-center' });
            //         // }
            //         //log error 
            //         if (err.status === 401) {
            //             this.router.navigate(['auth/login']);
            //         }
            //     }
            //     return of(err);
            // }),
            catchError((error) => {
 
                let handled: boolean = false;
                console.error(error);
                if (error instanceof HttpErrorResponse) {
                  if (error.error instanceof ErrorEvent) {
                    console.error("Error Event");
                  } else {
                    //console.log(`error status : ${error.status} ${error.statusText}`);
                    switch (error.status) {
                        case 401:      //login
                            this.router.navigate(['auth/login']);
                            //console.log(`redirect to login`);
                            handled = true;
                            break;
                        }
                    }
                }
                else {
                    console.error("Other Errors");
                }
                if (handled) {
                    console.log('return back ');
                    return of(error);
                } else {
                    console.log('throw error back to to the subscriber');
                    return throwError(error);
                }
 
        }),
            finalize(() => spinnerService.hide()));
    }
}